<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc"><a href="#/c01">Sex Noises</a></p>
<p class="toc"><a href="#/c02">No Man’s Land</a></p>
<p class="toc"><a href="#/c03">Those Aren’t My Tits</a></p>
<p class="toc"><a href="#/c04">Unsexy Sex</a></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Never Say Never</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">A Sexy, Wordless Tongue Conversation</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Licking the Snail</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">Welcome to the Family</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Scary Lesbian Eyes</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">A Sex-Cupboard Staple</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">Whips Are Very Twenty-First Century</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">A Salty Rim</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Aubergine Emoji</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Teflon-Coated by Happiness</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Emergency Doughnuts</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">No One Starts with Just One Juggling Ball</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">I Can Really See That You Are a Mammal</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">An Unusual Lesbian Saint</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">All Your Eggs in One Basket</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">Mr. Lover Lover</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">The Weapon of Mass Destruction</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">Gimp Masks and Wagon Wheels</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">Not That Kind of Married Person</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">I Hope You’ve Brought Your Pyjamas</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">All of the Bad Words</span></p>
<p class="toc"><span href="#/c26" title="Link target outside of Sample">Sam Loves Julia</span></p>
<p class="toc"><span href="#/c27" title="Link target outside of Sample">This Is Where the Magic Happens</span></p>
<p class="toc"><span href="#/c28" title="Link target outside of Sample">A Very Attractive Car Crash</span></p>
<p class="toc"><span href="#/c29" title="Link target outside of Sample"><em>Baise-Moi!</em></span></p>
<p class="toc"><span href="#/c30" title="Link target outside of Sample">Condoms on the Pillows</span></p>
<p class="toc"><span href="#/c31" title="Link target outside of Sample">Ménage à Trois</span></p>
<p class="toc"><span href="#/c32" title="Link target outside of Sample">Polyamory for Beginners</span></p>
<p class="toc"><span href="#/c33" title="Link target outside of Sample">Saving Contentment for My Retirement</span></p>
<p class="toc"><span href="#/c34" title="Link target outside of Sample">Elimination Day</span></p>
<p class="toc"><span href="#/c35" title="Link target outside of Sample">Vindictively Calm</span></p>
<p class="toc"><span href="#/c36" title="Link target outside of Sample">Very Scottish Tinnitus</span></p>
<p class="toc"><span href="#/c37" title="Link target outside of Sample">Shut It, Ya Bawbag!</span></p>
<p class="toc"><span href="#/c38" title="Link target outside of Sample">Shrivelled Pea</span></p>
<p class="toc"><span href="#/c39" title="Link target outside of Sample">A Terrible Humblebrag</span></p>
<p class="toc"><span href="#/c40" title="Link target outside of Sample">Lemon Drizzle vs. Blueberry Tart</span></p>
<p class="toc"><span href="#/c41" title="Link target outside of Sample">El Jefe</span></p>
<p class="toc"><span href="#/c42" title="Link target outside of Sample">No Weddings and a Funeral</span></p>
<p class="toc"><span href="#/c43" title="Link target outside of Sample">A Couple of Pirouettes</span></p>
<p class="toc"><span href="#/c44" title="Link target outside of Sample">Love, Actually?</span></p>
<p class="toc"><span href="#/c45" title="Link target outside of Sample">Shag-Pile Virgin</span></p>
<p class="toc"><span href="#/c46" title="Link target outside of Sample">A Dykey French Lieutenant’s Woman</span></p>
<p class="toc"><span href="#/c47" title="Link target outside of Sample">Back</span></p>
<p class="toc"><span href="#/c48" title="Link target outside of Sample">Residue</span></p>
<p class="toc"><span href="#/c49" title="Link target outside of Sample">Wow</span></p>
<p class="toc"><span href="#/c50" title="Link target outside of Sample">Christmas Spectacular</span></p>
<p class="toc"><span href="#/c51" title="Link target outside of Sample">It’ll Pass</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Reading Group Guide</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">A Conversation with Kate Davies</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">Connect with HMH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?27b7780f